import request from './request';

/**
 * 采集工况管理 API
 */

// 获取采集工况列表
export function getCollectionConditions(params) {
  return request.get('/collection-conditions', { params });
}

// 获取采集工况详情
export function getCollectionConditionById(id) {
  return request.get(`/collection-conditions/${id}`);
}

// 根据故障现象ID获取采集工况
export function getByFaultPhenomenonId(faultPhenomenonId) {
  return request.get(`/collection-conditions/by-fault-phenomenon/${faultPhenomenonId}`);
}

// 创建采集工况
export function createCollectionCondition(data) {
  return request.post('/collection-conditions', data);
}

// 更新采集工况
export function updateCollectionCondition(id, data) {
  return request.put(`/collection-conditions/${id}`, data);
}

// 删除采集工况
export function deleteCollectionCondition(id) {
  return request.delete(`/collection-conditions/${id}`);
}

// 获取故障现象标签列表（用于下拉选择）
export function getFaultPhenomenonTags() {
  return request.get('/collection-conditions/fault-phenomenon-tags');
}

// 下载导入模板
export function downloadTemplate() {
  return request.get('/collection-conditions/template', {
    responseType: 'blob'
  });
}

// 批量导入
export function importCollectionConditions(file) {
  const formData = new FormData();
  formData.append('file', file);
  return request.post('/collection-conditions/import', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

